export default __webpack_public_path__ + "static/underline-mobile-428415ba54bfe54f7758314361e72189.svg";